<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid content">
          <slot name="header" />
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Администрирование</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content">
          <div class="breadcrumb-wrapp">
            <a href="/administration/">Администрирование</a> >
            <span v-if="filter.type == 'es'">Чек-лист для экспертного совета</span>
            <span v-else-if="filter.type=='dz'">Чек-лист для подписания договора займа</span>
          </div>

          <div class="d-flex">
            <div class="wrap stl-df-ac">
              <router-link
                :to="{ name: 'AdminStatuses', params: {'type': filter.type} }"
                class="administration-page_m__item-link"
              >
                Статусы загрузки документов
              </router-link>
              <router-link
                v-if="filter.type == 'es'"
                :to="{ name: 'Acceptance' }"
                class="administration-page_m__item-link"
              >
                Акцептование документов
              </router-link>
            </div>
          </div>
          <div
            class="container-fluid mycontainer-fluid content table-responsive"
            style="padding-left: 0; padding-right: 0; background: none;"
          >
            <div style="padding: 10px 0;">
              <router-link
                :to="{ name: 'AdminStatuses', params: {'type': filter.type} }"
                class="administration-page__item-link"
              >
                <span class="header-link-back"></span> Программа:
                {{ getHeaderBackButton }}
              </router-link>
            </div>
            <div class="col-xs-12 mycol">
              <div class="status-filter-container">
                <div class="status-filter-container__form">
                  <!--<div class="status-filter-container__form-item">
                      <label for="sf-all">Всё</label>
                      <input
                        type="radio"
                        name="sf-group"
                        value="all"
                        v-model="filter.type"
                        id="sf-all"
                      />
                    </div>-->
                  <div class="status-filter-container__form-item">
                    <label for="sf-ec">ЭС</label>
                    <input
                      type="radio"
                      name="sf-group"
                      value="es"
                      v-model="filter.type"
                      id="sf-ec"
                      @click="gotoToNewPage('es')"
                    />
                  </div>
                  <div class="status-filter-container__form-item">
                    <label for="sf-dz">ДЗ</label>
                    <input
                      type="radio"
                      name="sf-group"
                      value="dz"
                      v-model="filter.type"
                      id="sf-dz"
                      @click="gotoToNewPage('dz')"
                    />
                  </div>
                  <div class="status-filter-container__form-item"
                       v-if="isSaveData"
                       style="background-color: #ffA500; padding: 0 4px;">
                    <img src="/img/waiting.gif" style="width:20px;" /> Идет сохранение данных, не обновляйте страницу
                  </div>
                  <!--<div class="status-filter-container__form-item">
                    <button
                      @click="fetchList"
                      class="butt-new-style project-filter__butt-btn"
                    >
                      Применить
                    </button>
                  </div>-->
                </div>
              </div>
            </div>
            <div class="col-xs-12 mycol">
              <table
                class="c-indicator c-indicator-w-100 c-indicator-admin js-table-thead-sticky"
              >
                <thead class="js-thead-sticky">
                <tr>
                  <th>№ п/п</th>
                  <th>Наименование документа</th>
                  <template v-if="filter.type == 'es'">
                    <th
                      v-for="program in statusLoadProgramList"
                      :key="program.ID"
                      v-show="!getStatusBlockCheck(program)"
                    >
                      {{ program.NAME }}
                    </th>
                  </template>
                  <th class="cnt" v-else>
                    Доступность в программе
                  </th>
                </tr>
                </thead>
                <tbody v-if="!isAdminStatusDocsLoading">
                <template v-for="(item, index) in adminStatusDocsItems">
                  <tr :key="getRandomInt() + `=item-${index}`" class="back-jur">
                    <td>{{ index + 1 }}</td>
                    <template v-if="filter.type == 'es'">
                      <td
                        :colspan="
                          programmActive.IS_REGIONAL_PROGRAMM
                            ? 2 + statusLoadProgramList.length
                            : statusLoadProgramList.length
                        "
                      >
                        <b>{{ item.SECTION_NAME }}</b>
                      </td>
                    </template>
                    <td v-else colspan="2">
                      <b>{{ item.SECTION_NAME }}</b>
                    </td>
                  </tr>
                  <template v-if="item.TYPE_LIST && item.TYPE_LIST.length > 0"
                  >
                    <tr
                      v-for="(type, idx) in item.TYPE_LIST"
                      :key="getRandomInt() + `=${idx}-${type.UF_NAME}-${type.ID}`"
                    >
                      <td>{{ index + 1 }}.{{ idx + 1 }}</td>
                      <td>
                        <router-link
                          :to="{
                              name: 'InfoDocument',
                              params: { id: type.ID },
                              query: {type: filter.type, programId: $route.params.id },
                            }"
                          class="administration-page_m__item-link"
                          v-html="type.UF_NAME"
                        />
                      </td>
                      <!-- Данные по программам -->
                      <template v-if="filter.type == 'es'">
                        <template
                          v-for="(program, idx) in type.STATUS_DATA_BY_PROG_ID[
                            $route.params.id
                          ]"
                        >
                          <td
                            v-show="!getStatusBlockCheck(program)"
                            :key="getRandomInt() + `=${program.UF_STATUS_ID}-${idx}`"
                          >
                            <input
                              type="checkbox"
                              v-model="program.VALUE"
                              :disabled="!isEdit"
                            />

                          </td>
                        </template>
                      </template>
                      <template v-else>
                        <td class="cnt">
                          <template v-for="checkDz in type.UF_IS_CHECK_LIST_DZ">
                            <input
                              v-if="checkDz.UF_SUPPORT_PROGRAM_ID == $route.params.id"
                              type="checkbox"
                              v-model="checkDz.UF_IS_CHECK_LIST"
                            />
                          </template>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <template v-if="item.CHILD && item.CHILD.length > 0">
                    <template v-for="(child, idx) in item.CHILD">
                      <tr
                        :key="getRandomInt() + `=${idx}-${child.SECTION_NAME}`"
                        class="back-jur"
                      >
                        <td>{{ index + 1 }}.{{ idx + ((item.TYPE_LIST.length>0)?item.TYPE_LIST.length+1:1) }}</td>

                        <template v-if="filter.type == 'es'">
                          <td
                          :colspan="
                              programmActive.IS_REGIONAL_PROGRAMM
                                ? 2 + statusLoadProgramList.length
                                : statusLoadProgramList.length
                            "
                        >
                          <b>{{ child.SECTION_NAME }}</b>
                        </td>
                        </template>
                        <td v-else colspan="2">
                          <b>{{ item.SECTION_NAME }}</b>
                        </td>
                      </tr>
                      <template
                        v-if="child.TYPE_LIST && child.TYPE_LIST.length > 0"
                      >
                        <tr
                          v-for="(type, indx) in child.TYPE_LIST"
                          :key="getRandomInt() + `${indx}-${type.UF_NAME}-${type.UF_IS_REQ}`"
                        >
                          <td>
                            {{ index + 1 }}.{{ idx + + ((item.TYPE_LIST.length>0)?item.TYPE_LIST.length+1:1) }}.{{ indx + 1 }}
                          </td>
                          <td>
                            <router-link
                              :to="{
                                  name: 'InfoDocument',
                                  params: { id: type.ID },
                                  query: {type: filter.type, programId: $route.params.id}
                                }"
                              class="administration-page_m__item-link"
                              v-html="type.UF_NAME"
                            />
                          </td>
                          <!-- Данные по программам -->
                          <template v-if="filter.type == 'es'">
                          <template
                            v-for="(program, idx) in type
                                .STATUS_DATA_BY_PROG_ID[$route.params.id]"
                          >
                            <td
                              v-show="!getStatusBlockCheck(program)"
                              :key="getRandomInt() + `=${program.UF_STATUS_ID}-${idx}`"
                            >
                              <input
                                type="checkbox"
                                v-model="program.VALUE"
                                :disabled="!isEdit"
                              />
                              {{ program.NAME }}
                            </td>
                          </template>
                          </template>
                          <template v-else>
                            <td class="cnt">
                              <template v-for="checkDz in type.UF_IS_CHECK_LIST_DZ">
                                <input
                                  v-if="checkDz.UF_SUPPORT_PROGRAM_ID == $route.params.id"
                                  type="checkbox"
                                  v-model="checkDz.UF_IS_CHECK_LIST"
                                />
                              </template>
                            </td>
                          </template>
                        </tr>
                      </template>

                      <!-- 2 уровень --->
<!--                      <template v-for="(child2, idx2) in child.CHILD">
                        <tr
                          :key="getRandomInt() + `=${idx2}-${child2.SECTION_NAME}`"
                          class="back-jur"
                        >
                          <td>{{ index + 1 }}.{{ idx + ((item.TYPE_LIST.length>0)?item.TYPE_LIST.length+1:1) }}.{{idx2+1}}</td>
                          <td :colspan="((filter.type=='es')?8:6) + programList.length">
                            <b>{{ child2.SECTION_NAME }}</b>
                          </td>
                        </tr>

                        <template v-if="filter.type == 'es'">
                        <template
                          v-if="child2.TYPE_LIST && child2.TYPE_LIST.length > 0"
                        >
                          <tr
                            v-for="(type2, indx2) in child2.TYPE_LIST"
                            :key="getRandomInt() + `=${indx2}-${type2.UF_NAME}-${type2.UF_IS_REQ}`"
                          >
                            <td>
                              {{ index + 1 }}.{{ idx + + ((item.TYPE_LIST.length>0)?item.TYPE_LIST.length+1:1) }}.{{ idx2 + 1 }}.{{ indx2 + 1 }}
                            </td>

                            <td>
                              <router-link
                                :to="{
                                  name: 'InfoDocument',
                                  params: { id: type2.ID},
                                  query: {type: filter.type}
                                }"
                                class="administration-page_m__item-link"
                                v-html="type2.UF_NAME"
                              />
                            </td>
                            <td>
                              <template v-if="filter.type=='es'">{{ type2.UF_EXT_TEXT }}</template>
                              <template v-else>{{ type2.UF_EXT_DZ_TEXT }}</template>
                            </td>
                            <td class="cnt" v-if="filter.type=='es'">
                              <input
                                type="checkbox"
                                v-model="type2.UF_IS_REQ"
                                :disabled="!isEdit"
                              />
                            </td>
                            <td v-if="filter.type=='es'">
                              <template v-if="isEdit">
                                <multiselect
                                  v-model="type2.UF_GROUP_LOAD_USER_ARR"
                                  :options="allGroupUserListComp"
                                  class="i-main-style stl-bs_bb multiselect-filter-project-register multiselect-multiline"
                                  :multiple="true"
                                  :limit="30"
                                  track-by="ID"
                                  label="NAME"
                                  placeholder
                                >
                                  <span slot="noOptions"
                                  >Группы не найдены</span
                                  >
                                  <span slot="noResult">Группы не найдены</span>
                                </multiselect>
                              </template>
                              <template v-else>
                                {{
                                  getNamesFromGroupLoadUserArr(
                                    type2.UF_GROUP_LOAD_USER_ARR
                                  )
                                }}
                              </template>
                            </td>
                            <td>{{ type2.UF_DATE_START }}</td>
                            <td>{{ type2.UF_DATE_END }}  </td>
                            &lt;!&ndash; Данные по программам &ndash;&gt;

                            <template v-for="(program, idxPrg) in programList">
                              <template v-if="filter.type=='es'">
                                <template v-if="isEdit">
                                  <td
                                    :key="
                                     getRandomInt() +  `=${idxPrg}-${program.CODE}-${program.NAME}`
                                    "
                                  >
                                    {{ type2.UF_STATUS_TEXT[idxPrg].SMALL }}
                                  </td>
                                </template>
                                <template v-else>
                                  <td
                                    :key="
                                    getRandomInt() + `=${idxPrg}-${program.CODE}-${program.NAME}`
                                  "
                                  >
                                    {{
                                      getStatusText(
                                        type2.UF_STATUS_TEXT || [],
                                        program.ID
                                      )
                                    }}
                                  </td>
                                </template>
                              </template>
                              <template v-else>
                                <td class="cnt"
                                    :key="getRandomInt() +  `=${idx}-${program.CODE}-${program.NAME}`">

                                  <template v-for="checkDz in type.UF_IS_CHECK_LIST_DZ">
                                    <input
                                      v-if="checkDz.UF_SUPPORT_PROGRAM_ID == program.ID"
                                      type="checkbox"
                                      v-model="checkDz.UF_IS_CHECK_LIST"
                                    />
                                  </template>

                                </td>
                              </template>
                            </template>

                            <td>{{ type2.UF_COMMENTS }}</td>
                            <td style="min-width: 30px;">
                              <i
                                v-if="isEdit"
                                class="i-edit centerIcon"
                                @click="showComment(type2)"
                              ></i>
                            </td>
                          </tr>
                        </template>
                        </template>
                        <template v-else>
                          <td class="cnt">
                            <template v-for="checkDz in type.UF_IS_CHECK_LIST_DZ">
                              <input
                                v-if="checkDz.UF_SUPPORT_PROGRAM_ID == $route.params.id"
                                type="checkbox"
                                v-model="checkDz.UF_IS_CHECK_LIST"
                              />
                            </template>
                          </td>
                        </template>

                      </template>-->
                      <!-- 2 уровень --->
                    </template>
                  </template>
                </template>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="2">Загрузка данных...</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer footer-fix">
      <div class="container-fluid mycontainer-fluid">
        <div v-if="isEdit" class="footer-sabmit">
          <button
            @click="fetchList"
            class="but-style but-ext screenplay-container"
            style="height: 30px;"
          >
            Отмена
          </button>
          <button
            @click="saveStatusesColumns"
            style="height: 30px;"
            class="but-style but-save screenplay-container"
          >
            Сохранить
          </button>
        </div>
        <div class="myfooter">
          <div class="myfooter-frp pull-left"></div>
          <div class="pull-right"></div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_ADMIN_STATUS_DOCS_LIST,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { AdminService, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Multiselect from "vue-multiselect";

export default {
  name: "AdminStatusesColumn",
  components: { Multiselect },
  title: "Статусы загрузки документов",
  data() {
    return {
      siteUrl: "",
      isEdit: false,
      programmActive: [],
      filter: {
        type: (this.$route.params.type && this.$route.params.type !== "") ? this.$route.params.type : "es"
      },
      isSaveData: false
    };
  },

  computed: {
    ...mapGetters([
      "adminStatusDocsItems",
      "allGroupUserList",
      "programList",
      "managerList",
      "statusAcceptancesProgramList",
      "statusLoadProgramList",
      "isAdminStatusDocsLoading"
    ]),
    getHeaderBackButton() {
      if (
        this.programList &&
        this.programList.length > 0 &&
        !this.isAdminStatusDocsLoading
      ) {
        return this.programList.find(el => el.ID == this.$route.params.id).NAME;
      }
      return "";
    },
    listConfig() {
      const q = {
        filter: {}
      };
      if (this.filter.type !== "") {
        q.filter.type = this.filter.type;
      }

      q.filter.idProgram = this.$route.params.id;
      console.log(q);

      return q;
    }
  },

  beforeRouteLeave(to, from, next) {
    this.adminStatusDocsItems = [];
    next();
  },

  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.isEdit = data.SETTING_RULES_ADMIN_MODULE.REPORTING_DOCUMENTS_IS_EDIT;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        /*if (data.IS_VIEW_PLAN_ES) {
          navMainMenu.push({
            name: "Заседания",
            route: "Experts"
          });
        }
        if (data.IS_VIEW_MONITOR_LIZING) {
          navMainMenu.push({
            name: "Мониторинг Лизинговых<br/> компаний",
            class: "two_line",
            route: "MonitoringLizingOrgs"
          });
        }
        if (data.IS_VIEW_GROUP_ORG) {
          navMainMenu.push({
            name: "Группы компаний",
            route: "GroupOrgs"
          });
        }
        navMainMenu.push({
          name: "Запросы",
          route: "Requests"
        });*/
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
    });

    this.fetchList();
    this.setActiveProgramm();
    //window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    fetchList() {
      this.$store.dispatch(FETCH_ADMIN_STATUS_DOCS_LIST, this.listConfig);
    },
    saveStatusesColumns() {
      this.isSaveData = true;
      return AdminService.saveListStatusLoadDocuments({
        TYPE_SAVE: "program_status_save",
        UF_SUPPORT_PROGRAM_ID: this.$route.params.id,
        fields: this.adminStatusDocsItems
      })
        .then(({ data }) => {
          if (!data.error) {
            this.$toasted.show("Сохранено", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
            this.fetchList();
          } else {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          }
          this.isSaveData = false;
        }, this)
        .catch(err => {
          console.log(err);
          this.isSaveData = false;
        });
    },
    setActiveProgramm() {
      this.programmActive = this.programList.find(
        el => el.ID == this.$route.params.id
      );
    },
    getStatusBlockCheck(program) {
      if (this.programmActive == undefined) {
        this.setActiveProgramm();
      }
      return !this.programmActive.IS_REGIONAL_PROGRAMM &&
      program.IS_REGIONAL_STATUS
        ? true
        : false;
    },
    gotoToNewPage(type) {
      if (this.filter.type !== type) {
        this.filter.type = type;
        this.$router.push({
          name: "AdminStatusesColumn",
          params: { id: this.$route.params.id, type: type }
        });
        this.fetchList();
      }
    },
    getRandomInt() {
      let rand =Math.floor(Math.random() * 10001);
      return rand
    },
    handleScroll() {
      return true;
      var tableTheadSticky = document.querySelector(
        "table.js-table-thead-sticky"
      );
      var theadSticky = document.querySelector("thead.js-thead-sticky");
      var headerHeight = document.querySelector(".header").offsetHeight;

      if (tableTheadSticky.getBoundingClientRect().top <= headerHeight) {
        theadSticky.classList.add("stl-thead-sticky");
        theadSticky.style.top = headerHeight + "px";

        var tableResponsive = tableTheadSticky.closest(".table-responsive");
        if (tableResponsive) {
          tableResponsive.classList.add("table-responsive-clip");
        }
      } else {
        theadSticky.classList.remove("stl-thead-sticky");
        theadSticky.style.top = "0";
      }
    }
  },
  beforeDestroy() {
    //window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table {
  min-width: 1500px;
}
</style>
